import { Component, OnInit } from '@angular/core';
import { NavParams, PopoverController } from '@ionic/angular';

@Component({
  selector: 'app-country-popup',
  templateUrl: 'countryPopup.html'
})
export class CountryPopup implements OnInit {
  allCountryData: any[] = [];
  countryData: any[] = [];
  selectedCountry: any = null;
  searchTerm = '';
  isLocationRed: boolean = false;

  constructor(
    private navParams: NavParams,
    private popoverController: PopoverController
  ) {}

  ngOnInit() {
      const business = JSON.parse(localStorage.getItem('selectedBusiness'));
      this.isLocationRed = business?.locationId === 940;
    this.allCountryData = this.sortCountries(this.navParams.data?.countryData || []);
    this.selectedCountry = this.navParams.data?.selectedCountry || null;
    this.countryData = this.prioritizeSelected(this.allCountryData);
  }

  searchCountry(term: string) {
    this.searchTerm = term || '';
    const query = this.normalizeSearchQuery(this.searchTerm);

    if (!query) {
      this.countryData = this.prioritizeSelected(this.allCountryData);
      return;
    }

    this.countryData = this.allCountryData.filter((item) => {
      const countryName = this.normalizeSearchQuery(item?.displayName || item?.name || '');
      const dialCode = this.normalizeSearchQuery(item?.phoneCode);
      return countryName.includes(query) || dialCode.includes(query);
    });
  }

  trackByCountry(_: number, country: any): number | string {
    return country?.id ?? `${country?.displayName || country?.name}-${country?.phoneCode}`;
  }

  getCountryName(country: any): string {
    return country?.displayName || country?.name || 'Unknown country';
  }

  getCountryDialCode(country: any): string {
    return country?.phoneCode ? `+${country.phoneCode}` : '';
  }

  private normalizeSearchQuery(value: any): string {
    return String(value || '')
      .toLowerCase()
      .replace(/\+/g, '')
      .replace(/\s+/g, '')
      .trim();
  }

  private sortCountries(countries: any[]): any[] {
    return [...countries].sort((a, b) =>
      this.getCountryName(a).localeCompare(this.getCountryName(b))
    );
  }

  private prioritizeSelected(countries: any[]): any[] {
    if (!this.selectedCountry?.id) {
      return countries;
    }

    const selectedIndex = countries.findIndex((item) => item?.id === this.selectedCountry?.id);
    if (selectedIndex <= 0) {
      return countries;
    }

    const ordered = [...countries];
    const [selected] = ordered.splice(selectedIndex, 1);
    return [selected, ...ordered];
  }

  selectCountry(country: any) {
    this.selectedCountry = country;
    this.popoverController.dismiss(country);
  }

  close() {
    this.popoverController.dismiss();
  }
}
